import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Logo } from '@growhero/brand';
import { Button, Illustration } from '@/ui';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-[70dvh] place-items-center px-6 py-16 text-center">
      <div className="max-w-md animate-rise">
        <Illustration name="search" className="mx-auto w-48" />
        <div className="eyebrow mt-6 text-primary-ink">404</div>
        <h1 className="display-heavy mt-2 text-[2rem]">{t('notFound.title')}</h1>
        <p className="mt-2 text-ink-muted">{t('notFound.body')}</p>
        <Button asChild className="mt-8">
          <Link to="/">{t('notFound.home')}</Link>
        </Button>
      </div>
    </div>
  );
}

/** Router-level error boundary (render errors, failed lazy chunks). */
export function RouteErrorPage() {
  const { t } = useTranslation();
  const err = useRouteError();
  if (isRouteErrorResponse(err) && err.status === 404) return <NotFoundPage />;
  if (import.meta.env.DEV) console.error(err);
  const chunk =
    err instanceof Error && /dynamically imported module|Loading chunk/i.test(err.message);
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-6 text-center">
      <div className="max-w-md">
        <Logo height={26} className="mx-auto mb-10" />
        <h1 className="display-heavy text-[2rem]">
          {chunk ? t('errors.updatedTitle') : t('errors.genericTitle')}
        </h1>
        <p className="mt-2 text-ink-muted">
          {chunk ? t('errors.updatedBody') : t('errors.genericBody')}
        </p>
        <div className="mt-8 flex justify-center gap-2">
          <Button onClick={() => window.location.reload()}>{t('actions.reload')}</Button>
          <Button asChild variant="secondary">
            <a href="/">{t('notFound.home')}</a>
          </Button>
        </div>
        {import.meta.env.DEV && err instanceof Error && (
          <pre className="mt-8 overflow-auto rounded-md bg-sunken p-3 text-left text-xs text-negative-ink">
            {err.message}
          </pre>
        )}
      </div>
    </div>
  );
}
